import { createSelector } from 'reselect';
import DespatchMonitoringEventTargetsCompactColumns
  from '../../containers/DespatchMonitoringEventTargetsCompactColumns';
import DespatchMonitoringEventTargetsDetailsColumns
  from '../../containers/DespatchMonitoringEventTargetsDetailsColumns';
import ReportsDefinition from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.DESPATCH_MONITORING_EVENT_TARGETS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.DESPATCH_MONITORING_EVENT_TARGETS.isLoading;

export const getData = ReportsDefinition.DESPATCH_MONITORING_EVENT_TARGETS.getDataFunction();

export const getCompactColumns = createSelector(
  getData,
  DespatchMonitoringEventTargetsCompactColumns,
);

export const getDetailsColumns = createSelector(
  getData,
  DespatchMonitoringEventTargetsDetailsColumns,
);
